import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgForKeyDirective } from '../../../directives/ng-for-track-by-id.directive';

export interface TitleButton {
	onClick?: (args: any) => any;
	label: string;
	color?: ThemePalette;
	icon?: string;
	cssClass?: string;
	ariaLabel?: string;
	/** If this callback includes a signal, it will be tracked and the button will update automatically. */
	hidden?: () => boolean;
	/** If this callback includes a signal, it will be tracked and the button will update automatically. */
	disabled?: () => boolean;
}

@Component({
    selector: 'sl-title-buttons',
    templateUrl: './title-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        NgForKeyDirective,
        MatButtonModule,
        NgClass,
        MatIconModule,
        MatMenuModule,
    ],
})
export class TitleButtonsComponent {
	@Input()
	asMenu = false;

	@Input()
	menuLabel: string;

	@Input()
	public set buttons(value: TitleButton[]) {
		if (value && value.length > 0) {
			this.allButtons.set(value);
		}
	}

	private readonly allButtons = signal<TitleButton[]>([]);

	/** Evaluated inside a computed so any signals read by a button's `hidden` callback are tracked. */
	public readonly visibleButtons = computed(() =>
		this.allButtons().filter((item) => (item.hidden ? !item.hidden() : true))
	);
}
